import React, { FC } from 'react';
import { TColor } from '@src/models/common';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';

import styled from './Divider.scss';

type TDividerView = TColor;

interface IProps extends IDefaultComponentProps {
  view?: TDividerView;
}

/**
 * Разредитель
 */
export const Divider: FC<IProps> = ({ view = 'basicGreySemiDark', className, style }) => {
  const classes = classnames(
    styled.root,
    className,
    ...getClasses(
      styled,
      {
        view,
      },
      undefined,
    ),
  );

  return <div className={classes} style={style} />;
};
